module.exports = __webpack_public_path__ + "static/media/pag-QueroSerLojista-ebit-06.163028bb.163028bb.png";